/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form } from '@mairistem/composants';
import {
  Section,
  EtatCivil,
  TypeComponent,
} from '@mairistem/administres-utils';

import { ChampLieu } from '@/components/Common';
import { OPTIONS_SEXE_ETCV } from '@/constants';

interface InformationsEnfantProps {
  data: Record<string, any>;
  errors?: Record<string, string>;
  onChange: (event: React.SyntheticEvent | null, payload: any) => void;
  /**
   * Affiche la section « Lieu de naissance » (défaut `true`, comportement
   * naissance inchangé). `false` en reconnaissance : décision produit
   * explicite, pas de lieu de naissance enfant à cette étape (cf. bloc
   * « INFORMATIONS SUR L'ÉVÉNEMENT » pour le lieu de reconnaissance).
   */
  showLieuNaissance?: boolean;
  /**
   * Variante d'affichage de l'état civil (défaut `NAISSANCE`), à faire
   * correspondre au type d'acte en cours (cf. `constants/typeComponentByTypeActe`).
   */
  typeComponent?: TypeComponent;
  /**
   * Options du champ « Sexe » (défaut : Masculin / Féminin).
   * `OPTIONS_SEXE_ETCV_AVEC_INDETERMINE` là où « Indéterminé » est prévu.
   */
  optionsSexe?: typeof OPTIONS_SEXE_ETCV;
  /** Grise « Né le » et « à » : reconnaissance avant la naissance (AD-12845). */
  disabledNaissance?: boolean;
}

const InformationsEnfant = (props: InformationsEnfantProps) => {
  const {
    data,
    errors = {},
    onChange,
    showLieuNaissance = true,
    typeComponent = TypeComponent.NAISSANCE,
    optionsSexe = OPTIONS_SEXE_ETCV,
    disabledNaissance = false,
  } = props;

  return (
    <Section title="INFORMATIONS SUR L'ENFANT" height="auto">
      {/* @ts-ignore */}
      <Form style={{ padding: '8px 14px' }}>
        <EtatCivil
          title="État civil"
          typeComponent={typeComponent}
          optionsSexe={optionsSexe}
          disabledNaissance={disabledNaissance}
          individu={data}
          errors={errors}
          onChange={onChange}
        />
        {showLieuNaissance && (
          <ChampLieu data={data} errors={errors} onChange={onChange} />
        )}
      </Form>
    </Section>
  );
};

export default InformationsEnfant;
